export class CaseInsensitiveSet extends Set<string> {
    private _dict: Map<string, string>

    constructor(iterable?: Iterable<string>) {
        super()
        this._dict = new Map<string, string>()
        if (iterable) {
            for (const key of iterable) {
                this.add(key)
            }
        }
    }

    public readonly [Symbol.toStringTag] = 'Set'

    public add(key: string): this {
        const k = key.toLowerCase()
        this._dict.set(k, key)
        return super.add(k)
    }

    public has(value: string): boolean {
        return super.has(value.toLowerCase())
    }

    public delete(key: string): boolean {
        const k = key.toLowerCase()
        this._dict.delete(k)
        return super.delete(k)
    }

    public [Symbol.iterator](): IterableIterator<string> {
        return new Set(this._dict.values())[Symbol.iterator]()
    }

    public entries(): IterableIterator<[string, string]> {
        return new Set(this._dict.values()).entries()
    }

    public forEach(
        callbackfn: (value: string, value2: string, set: CaseInsensitiveSet) => void,
        thisArg?: unknown,
    ): void {
        new Set(this._dict.values()).forEach((value, value2) => {
            callbackfn.call(thisArg ? thisArg : this, value, value2, this)
        })
    }

    public keys(): IterableIterator<string> {
        return this._dict.values()
    }

    public values(): IterableIterator<string> {
        return this._dict.values()
    }
}
